import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import ReactGA from 'react-ga';
import { StripeProvider } from 'react-stripe-elements';

import PlanSummary from './PlanSummary';
import PaymentMethod from './PaymentMethod';
import InvoiceList from './InvoiceList';

import './index.scss';

export default class Billing extends React.Component {
  constructor() {
    super();

    this.state = {};

    this.onResendClick = this.onResendClick.bind(this);
    this.onPlanChangeClick = this.onPlanChangeClick.bind(this);
    this.onPlanUnsubscribeClick = this.onPlanUnsubscribeClick.bind(this);
  }

  componentDidMount() {
    ReactGA.pageview(window.location.hash);
    // Fetch billing info
    this.props.getActivePlan();

    // Fetch past invoices
    this.props.getInvoices();

    // Fetch saved cards
    // this.props.getCards();

    // Fetch default card
    this.props.getDefaultCard();

    // Fetch available plans
    this.props.getAvailablePlans();

    // Fetch client
    this.props.getClient();
  }

  // Note: This should not be required now, since we have a way to fetch invoices using userId now
  // componentWillReceiveProps(nextProps) {
  // Sometimes, business info is loaded after component is mounted. In that case, fetch invoices again
  // if (nextProps.business.info.EMAIL !== this.props.business.info.EMAIL) {
  //   this.props.getInvoices();
  // }
  // }

  onResendClick(invoice) {
    this.props.sendInvoiceEmail({
      invoiceId: invoice.invoiceid,
      invoiceNumber: invoice.invoice_number,
      amount: invoice.amount,
      dueDate: moment(invoice.due_date, 'YYYY-MM-DD').format('Do MMM, YYYY'),
    });
  }

  onPlanUnsubscribeClick() {
    if (window.confirm('Are you sure, you want to continue?')) {
      this.props.unsubscribePlan();
    }
  }

  onPlanChangeClick() {
    this.props.history.push('/app/plans');
  }

  render() {
    return (
      <div className="billing">
        <PlanSummary
          currentDomain={this.props.currentDomain}
          client={this.props.billing.client}
          onUnsubscribe={this.onPlanUnsubscribeClick}
          onChangePlan={this.onPlanChangeClick}
        />
        <div className="billing-separator" />
        <StripeProvider apiKey={window.Config.STRIPE_API_KEY}>
          <PaymentMethod {...this.props} />
        </StripeProvider>
        <div className="billing-separator" />
        <InvoiceList
          invoices={this.props.billing.list}
          onResend={this.onResendClick}
        />
      </div>
    );
  }
}

Billing.defaultProps = {
  getClient: () => {},
  getAvailablePlans: () => {},
  unsubscribePlan: () => {},
  getActivePlan: () => {},
  getInvoices: () => {},
  sendInvoiceEmail: () => {},
  getDefaultCard: () => {},
  currentDomain: '',
  router: {
    push: () => {},
  },
};

Billing.propTypes = {
  getClient: PropTypes.func,
  getAvailablePlans: PropTypes.func,
  unsubscribePlan: PropTypes.func,
  getActivePlan: PropTypes.func,
  getInvoices: PropTypes.func,
  sendInvoiceEmail: PropTypes.func,
  getDefaultCard: PropTypes.func,
  currentDomain: PropTypes.string,
  billing: PropTypes.shape({
    list: PropTypes.array,
    client: PropTypes.object,
  }).isRequired,
  router: PropTypes.shape({
    push: PropTypes.func,
  }),
};
